import { findElement, selectedElementAll } from "../utils/element-handlers.utils";

function LangButtonComponent(langButtonElement: HTMLElement) {
    const dropdownElement = findElement('.n-lang-button-dropdown', langButtonElement);

    if (dropdownElement) {
        ((dropdownElement) => {
            let isOpen: boolean = false;
            let isBusy: boolean = false;

            langButtonElement.addEventListener('click', openDropdownEvent);
            dropdownElement.addEventListener('click', event => event.stopPropagation());
            document.addEventListener('click', closeDropdownEvent);
            window.addEventListener('scroll', () => {
                if (!isBusy && isOpen) closeDropdown();
            });
            window.addEventListener('resize', () => {
                if (!isBusy && isOpen) closeDropdown();
            });

            function openDropdownEvent(event: MouseEvent) {
                if (isBusy || isOpen) return;
                event.preventDefault();
                event.stopPropagation();
                openDropdown();
            }
    
            function closeDropdownEvent(event: MouseEvent) {
                if (isBusy || !isOpen) return;
                closeDropdown();
            }

            function openDropdown() {
                langButtonElement.classList.add('n-active');
                dropdownElement.classList.add('n-active');
                window.setTimeout(() => dropdownElement.classList.add('n-visible'), 0);
                isOpen = true;
            }

            function closeDropdown() {
                isBusy = true;
                langButtonElement.classList.remove('n-active');
                dropdownElement.classList.remove('n-visible');
                window.setTimeout(() => {
                    dropdownElement.classList.remove('n-active');
                    isBusy = false;
                }, 300);
                isOpen = false;
            }
        })(dropdownElement);
    }
}

export default function initLangButtonComponents() {
    selectedElementAll('button.n-lang-button', LangButtonComponent);
}
